<div class="d-flex flex-column justify-content-start announcement-dialog-container">
  <div class="d-flex justify-content-end" >
    <img class="cursor-pointer" [src]="'assets/svg-icons/close.svg'" alt="cursor icon" (click)="toggleAnnouncementDialog()"/>
  </div>
  <div class="d-flex flex-row gap-3 ps-4 pe-4">
    <div class="d-flex align-items-start justify-content-start mt-2 pt-1">
      <img [src]="'assets/svg-icons/release.svg'" alt="{{'help.releaseHelp.1-1.title'|translate}}"/>
    </div>
    <div class="d-flex flex-column gap-1 w-100">
      <span class="title">{{ (announcement$|async)?.attributes.title }}</span>
      <span class="subtitle">
        <!-- New line in markdown is 2 spaces and new line -->
        <markdown [data]="(announcement$|async)?.attributes.content"></markdown>
      </span>
      <div *ngIf="(announcement$|async)?.attributes.video" class="w-100 video-container">
        <iframe [src]="'https://player.vimeo.com/video/' + (announcement$|async)?.attributes.video | safe"
                allow="autoplay; fullscreen; picture-in-picture"
                title="{{'help.releaseHelp.1-1.title'|translate}}"></iframe>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center ps-4 pe-4">
    <mat-checkbox [(ngModel)]="disableAnnouncementDialog">{{'announcementDialog.noDisplay'|translate}}</mat-checkbox>
  </div>
  <div class="w-100 d-flex justify-content-center ps-4 pe-4">
    <button class="close-button" (click)="toggleAnnouncementDialog()">{{'announcementDialog.close'|translate}}</button>
  </div>
</div>
